import { render, staticRenderFns } from "./ExecPromotions.vue?vue&type=template&id=35f8bb56"
import script from "./ExecPromotions.vue?vue&type=script&lang=js"
export * from "./ExecPromotions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports